import { useState } from "react";

import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { useErrorBanner, useModal } from "@hooks";
import { i18n, Translations } from "@i18n";

export type CancelWithdrawalModalProps = {
  onConfirm: () => void | Promise<void>;
  amount?: string;
  date?: string;
};

export const CancelWithdrawalModal = ({ onConfirm, amount, date }: CancelWithdrawalModalProps) => {
  const { dismiss } = useModal();
  const [loading, setLoading] = useState(false);
  const { showErrorBanner } = useErrorBanner();

  const handleConfirm = async () => {
    setLoading(true);

    try {
      await onConfirm();
      dismiss();
    } catch {
      dismiss();
      setTimeout(showErrorBanner, 0);
    } finally {
      setLoading(false);
    }
  };

  const subtitle = (() => {
    if (amount && date) {
      return i18n.t(Translations.CancelWithdrawalModalSubtitleWithAmountAndDate, {
        amount,
        date,
      });
    }
    if (amount) {
      return i18n.t(Translations.CancelWithdrawalModalSubtitleWithAmount, { amount });
    }
    return i18n.t(Translations.CancelWithdrawalModalSubtitle);
  })();

  const props: OverlayProps = {
    title: i18n.t(Translations.CancelWithdrawalModalTitle),
    subtitle,
    horizontal: true,
    cta: {
      primary: {
        title: i18n.t(Translations.CancelWithdrawalModalYesCTA),
        onClick: handleConfirm,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.CancelWithdrawalModalNoCTA),
        onClick: dismiss,
      },
    },
  };

  return <Overlay {...props} />;
};
